import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent'
import AppBar from '../../commons/AppBar'
import SegmentButtons from '../../commons/SegmentButtons'
import Ws from '../../providers/Ws';
import CardsDynamic from '../../commons/CardsDynamic'
import Utils from '../../providers/Utils';
import { Fab, Grid, Divider } from '@material-ui/core';
import AddProject from '../../commons/dialogs/AddProject'
import FromServer from './FromServer';
import GanttProiecteWeekView from '../../commons/GanttProiecteWeekView'
import GanttProiecteMonthView from '../../commons/GanttProiecteMonthView'
import avatar from '../../Pics/avatar.jpg'
import LocalStorage from '../../providers/LocalStorage';
import ButtonsModules from '../../commons/ButtonsModules'

export default class UserProiecte extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            proiecte: [],
            isOpenInsert: false,
            strNumeProiect: this.dictionary.proiecte.numeProiect,
            dtStartDate: new Date(),
            objPerioadaGantt: {},
            listEtape: []


        }
    }


    componentDidMount() {
        this.getProiecte()
    }

    goToPage=(page)=>{

        this.props.history.push(`/${page}`)
    }


    dataAzi = () => {
        let u = new Utils()

        let dataAzi = u.defaultData()

        if (this.dictionary.date === 'en') {
            return u.dataPrescurtataEng(dataAzi)
        } else {
            return u.dataPrescurtataRomana(dataAzi)
        }
    }


    getProiecte = async () => {

        let ws = new Ws();

        let u = new Utils();

        let fS = new FromServer();

        let _proiecte = fS.getProiecte( this.props.match.params.iduser)
        // console.log('proiecte :', _proiecte);

        let _etape = fS.getEtapeAll()

        let [proiecte, etape, t] = await Promise.all([_proiecte, _etape, fS.getTaskuriAll(this.props.match.params.iduser)])

        // console.log('etape :', etape);

        if (proiecte.Succes) {

            // console.log('t :', t);

            let cloneEtape = [...etape]



            let cloneTaskuri = [...t]

            let counter2 = cloneEtape.length

            for (let i = 0; i < counter2; i++) {
                let filterTaskuri = cloneTaskuri.filter(t => t.id_etapa_proiect === cloneEtape[i].id)


                // console.log('cloneTaskuri :', cloneTaskuri);


                filterTaskuri = filterTaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(cloneEtape[i].durata_pana_la) && new Date(u.ParseDataFromSql(t.pana_cand_data)) < new Date(cloneEtape[i].durata_pana_la)))

                filterTaskuri = filterTaskuri.filter(t => t.pana_cand_data !== null)

                filterTaskuri = filterTaskuri.filter(t => t.statusul !== 'Finalizat')

                // console.log('filterTaskuri :', filterTaskuri);

                let taskuriTrecute = filterTaskuri.filter(t => new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date())

                let taskuriInViitor = filterTaskuri.filter(t => new Date(u.ParseDataFromSql(t.cand_data)) > new Date())

                if (filterTaskuri.length > 0) {
                    if (taskuriTrecute.length > 0) {
                        cloneEtape[i].color = '#ff3f3f'
                    } else if (filterTaskuri.length === taskuriInViitor.length) {
                        cloneEtape[i].color = 'rgb(58, 180, 209)'
                    } else {
                        cloneEtape[i].color = 'rgb(251, 141, 0)'
                    }

                } else {
                    cloneEtape[i].color = 'rgb(122, 209, 58)'
                }



                //     cloneEtape[i].color = '#ff3f3f'
                // }else if (filterTaskuri.length > 0){
                //     cloneEtape[i].color = 'rgb(247, 167, 16)'
                // }else{
                //     cloneEtape[i].color = '#7ad13a'
                // }

            }



            // console.log('cloneEtape :', cloneEtape);


            let cloneProiecte = [...proiecte.Content]

            let counter = cloneProiecte.length

            let perioadaDeLa = u.defaultData()

            let perioadaPanaLa = u.defaultDataPlus3Months();

            for (let i = 0; i < counter; i++) {


                cloneProiecte[i].perioada_dela = u.ParseDataFromSql(cloneProiecte[i].perioada_dela)
                cloneProiecte[i].perioada_panala = u.ParseDataFromSql(cloneProiecte[i].perioada_panala)
            }

            for (let i = 0; i < counter; i++) {
                if (new Date(cloneProiecte[i].perioada_dela) < new Date(perioadaDeLa)) {
                    perioadaDeLa = cloneProiecte[i].perioada_dela
                }

                if (new Date(cloneProiecte[i].perioada_panala) > new Date(perioadaPanaLa)) {
                    perioadaPanaLa = cloneProiecte[i].perioada_panala
                }
            }

            // console.log('perioadaDeLa :', perioadaDeLa);
            // console.log('perioadaPanaLa :', perioadaPanaLa);



            // console.log('Cloneproiecte :', cloneProiecte);

            this.setState({
                proiecte: cloneProiecte,
                objPerioadaGantt: { dtPerioadaDeLa: perioadaDeLa, dtPerioadaPanaLa: perioadaPanaLa },
                listEtape: cloneEtape
            })
        }
    }


    onProiectSelectat = (p) => {
       
        this.props.history.push(`/useretape/${this.props.match.params.iduser}/${p.id}`)
    }

  

    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.proiecteUser} />


                
                    <ButtonsModules 
                    scop='Management Proiecte'
                    idUser={this.props.match.params.iduser}
                    history={this.props.history}/>
                    


                <Divider className="pm-divider" />



                <div style={{ position: 'relative' }}>
                   
                    {/* {this.state.proiecte.length > 0 && 
            <div style={{height:'40vh', overflow:'scroll', width:'95%', margin:'auto'}}>
            <CardsDynamic elemente={this.state.proiecte}
                          onlyColumns = {{title:'titlu', content:'descriere' }}
                          onElementClick ={this.onProiectSelectat}
                          dictionary={this.dictionary}
                          />
            
            
            
            </div>  } */}



                    <div style={{ width: '100%', overflow: 'hidden', minHeight: '85vh', height: '100%', position: 'relative' }}>

                        <h3 style={{ width: 'fit-content', margin: 'auto', borderBottom: '1px solid gray' }} className='pm-title'>{this.dataAzi()}</h3>
                        <div style={{ height: '100%', position: 'absolute', left: 0, right: 0, margin: 'auto', width: 1, backgroundColor: '#e0e0e0' }}></div>
                        {/* <div  style={{ marginTop:20, overflowX:'scroll', overflowY:'hidden', textAlign:'left', height:'100%', display:'flex', position:'relative'}}> */}



                        {/* <GanttProiecteWeekView
                    dictionary={this.dictionary}
                    objPerioadaGantt={this.state.objPerioadaGantt}
                    listEtape={this.state.listEtape}
                    listProiecte={this.state.proiecte}
                    history={this.props.history}
                    /> */}

                        <GanttProiecteMonthView
                            objPerioadaGantt={this.state.objPerioadaGantt}
                            listEtape={this.state.listEtape}
                            listProiecte={this.state.proiecte}
                            history={this.props.history}
                            dictionary={this.dictionary}
                            idProiect={[{ id: 'infoUser' }]}
                            idUser={this.props.match.params.iduser}

                        />



                        {/* </div> */}
                    </div>
                </div>
            </div>
        );
    }
}